import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const kejianrouter = [
  {
    path: "/",
    name: "home",
    component: () => import("./views/Home.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("./views/News.vue"),
  },
  {
    path: "/YaoPin",
    name: "YaoPin",
    component: () => import("./views/YaoPin/index.vue"),
  },
  {
    path: "/YaoPinDetails/:id",
    name: "YaoPinDetails",
    component: () => import("./views/YaoPin/Details.vue"),
  },
  {
    path: "/Qixie",
    name: "Qixie",
    component: () => import("./views/Qixie/index.vue"),
  },
  {
    path: "/QixieDetails/:id",
    name: "QixieDetails",
    component: () => import("./views/Qixie/Details.vue"),
  },
  {
    path: "/newsdetails/:id",
    name: "newsdetails",
    component: () => import("./views/NewsDetails.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("./views/Product.vue"),
  },
  {
    path: "/case",
    name: "case",
    component: () => import("./views/Case.vue"),
  },
  {
    path: "/casedetails/:id",
    name: "casedetails",
    component: () => import("./views/CaseDetails.vue"),
  },
  {
    path: "/goin",
    name: "goin",
    component: () => import("./views/GoIn.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () => import("./views/Download.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/Login.vue"),
  },
];
export default new Router({
  routes: kejianrouter,
});
